var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_vm._t("cards")],2),_c('div',{staticClass:"row"},[_vm._t("data")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }